var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgBeverage = function SvgBeverage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Beverage_svg__clip0_1120_204736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 1.5h-4V.75c0-.199.084-.39.234-.53.15-.141.354-.22.566-.22h2.4c.212 0 .416.079.566.22.15.14.234.331.234.53v.75z",
    fill: "#F7A46B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 5.522V6.5h-8v-.978c0-.293.101-.58.29-.82L13.234 1.5h3.406l2.07 3.202c.188.24.289.527.289.82z",
    fill: "url(#Beverage_svg__paint0_linear_1120_204736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6 20.845c0 .638-.716 1.155-1.6 1.155-.884 0-1.6-.517-1.6-1.155 0 .306-.126.6-.351.817-.226.216-.53.338-.849.338-.318 0-.623-.122-.848-.338a1.134 1.134 0 01-.352-.817l.4-6.163-.4-2.696V5.5h8v6.486l-.4 2.696.4 6.163c0 .306-.126.6-.352.817-.224.216-.53.338-.848.338-.318 0-.623-.122-.849-.338a1.134 1.134 0 01-.351-.817z",
    fill: "url(#Beverage_svg__paint1_linear_1120_204736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7h8v5h-8V7z",
    fill: "url(#Beverage_svg__paint2_linear_1120_204736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.65 10.17V8.48h-6.8v1.69L3 11.86v8.45L3.85 22h6.8l.85-1.69v-8.45l-.85-1.69z",
    fill: "url(#Beverage_svg__paint3_linear_1120_204736)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.65 10.17H9.8a.426.426 0 01-.425-.422.421.421 0 01.425-.423h.85v.845z",
    fill: "url(#Beverage_svg__paint4_linear_1120_204736)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M3.85 9.325H8.1a.426.426 0 01.425.423.421.421 0 01-.425.422H3.85v-.845z",
    fill: "url(#Beverage_svg__paint5_linear_1120_204736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11.86h8.5v8.45H3v-8.45z",
    fill: "#E84A47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.458 20.31c.747-1.31 1.456-2.535 1.456-4.647 0-1.327-.457-2.591-.938-3.803h-1.7c.481 1.212.938 2.476.938 3.803 0 2.112-.709 3.337-1.456 4.647h1.7z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Beverage_svg__paint0_linear_1120_204736",
    x1: 15,
    y1: 1.5,
    x2: 15,
    y2: 10.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96E1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Beverage_svg__paint1_linear_1120_204736",
    x1: 14.807,
    y1: 5.754,
    x2: 18.535,
    y2: 21.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3A73C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Beverage_svg__paint2_linear_1120_204736",
    x1: 15,
    y1: 7,
    x2: 15,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD7E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Beverage_svg__paint3_linear_1120_204736",
    x1: 7.25,
    y1: 8.48,
    x2: 7.25,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Beverage_svg__paint4_linear_1120_204736",
    x1: 9.371,
    y1: 10.305,
    x2: 11.075,
    y2: 10.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Beverage_svg__paint5_linear_1120_204736",
    x1: 3.835,
    y1: 10.305,
    x2: 6.898,
    y2: 10.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Beverage_svg__clip0_1120_204736"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default __webpack_public_path__ + "static/media/Beverage.3680293b.svg";
export { SvgBeverage as ReactComponent };